export const AFFILIATE_LINKS = {
  ONLINE_THERAPY: "https://go.online-therapy.com/SHx7",
  AMAZON_STOREFRONT: "https://www.amazon.com/shop/shedeservesbetter", // Placeholder for their storefront
  BOOKS: {
    ATTACHED: "https://amzn.to/3ODCjjp",
    DRAMA_OF_GIFTED_CHILD: "https://amzn.to/4cVPUfM"
  }
};
